import { ACTION_NAMES } from "../../../constants/actionBar";
import {
  setToolPanel,
  setAdvancedQueryPanel,
  setSavedQueriesPanel,
} from "../../../redux/reducers/gridLayoutReducer";

/**
 * Function to process the action definition of a filter action. It adds `children` to the action definition based on the `filterParams`
 * provided in the action definition.
 * @param {Object} filterActionDef The action definition of the filter action.
 * @param {Function} t The translation function from i18next.
 * @param {Function} dispatch The dispatch function from the redux store.
 * @returns {Object} The processed action definition.
 */
export const processFilterActionDef = (filterActionDef, t, dispatch) => {
  if (!filterActionDef.filterParams?.gridName) {
    throw new Error(
      "SFActionBar: The filter action definition must have `filterParams.gridName` defined. Current value: " +
        filterActionDef.filterParams?.gridName
    );
  }

  return {
    ...filterActionDef,
    // Add children to the action definition only if the gridName is provided in the filterParams
    children: filterActionDef.filterParams.gridName && [
      {
        name: ACTION_NAMES.BASIC_FILTERS,
        label: t("components.datagrid.filters.basicFiltersHeader"),
        onClick: () =>
          dispatch(
            setToolPanel({
              gridName: filterActionDef.filterParams.gridName,
              open: true,
              name: "basicFilters",
            })
          ),
      },
      // Add advanced query and saved queries children only if the advancedQuery flag is set to true in the filterParams
      ...(filterActionDef.filterParams.advancedQuery
        ? [
          {
            name: ACTION_NAMES.ADVANCED_QUERY,
            label: t("components.datagrid.filters.advancedQuery.header"),
            onClick: () => {},
            children: [
              {
                name: ACTION_NAMES.NEW_QUERY,
                label: t("components.datagrid.filters.newQueryHeader"),
                onClick: () =>
                  dispatch(
                    setAdvancedQueryPanel({
                      gridName: filterActionDef.filterParams.gridName,
                      open: true,
                      query: null,
                    })
                  ),
              },
              {
                name: ACTION_NAMES.SAVED_QUERIES,
                label: t("components.datagrid.filters.savedQueriesHeader"),
                onClick: () =>
                  dispatch(
                    setSavedQueriesPanel({
                      gridName: filterActionDef.filterParams.gridName,
                      open: true,
                    })
                  ),
              },
            ],
          },
        ]
        : []),
    ],
  };
};
